import { createRoot } from "react-dom/client";
import App from "./App";
import "./landing.css";

createRoot(document.getElementById("root")!).render(<App />);
